<template>
  <div class="widget">
    <div class="widget-label">
      <div class="label">
        <p>Attendance</p>
      </div>
    </div>
    <div class="widget-content">
      <b-row v-if="checkStatus">
        <b-col cols="12">
          <div class="mb-2 custom-search dark position-relative">
            <font-awesome-icon
              icon="search"
              size="1x"
              class="position-absolute"
              style="color: 90a0b7; height: 100%; left: 16px; top: 0px"
            />
            <div
              v-if="searchText.length > characterLength"
              class="custom-search__result"
            >
              <span style="opacity: 0">{{ searchText }}</span>
              <span
                class="custom-search__result--left-over"
                :style="textSpace ? 'margin-left: 3.5px' : ''"
                v-for="(text, i) in searchResult"
                :key="i"
              >
                {{ text }}
              </span>
            </div>
            <b-form-input
              type="search"
              placeholder="Search colleague"
              class="pl-5 custom-search__input"
              v-model="searchText"
              @keyup.enter="handleSearchSubmit"
            />
            <div
              class="position-absolute w-100 custom-search__modal widget"
              :class="searchText.length > characterLength ? 'open' : ''"
            >
              <AttendeesList
                :attendees="attendeeSearchResults"
                emptyText="No users found in this search"
                class="search__results"
                action="Mark"
                :projectTags="projectTags"
                :searchText="searchText"
                :allowShowAll="false"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="no-card">
            <AttendeesList
              :attendees="attendees"
              column
              :emptyText="
                checkStatus
                  ? 'Add an attendee!'
                  : 'No attendees for this meeting'
              "
              :action="checkStatus ? 'Unmark' : ''"
              :showAll="true"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AttendeesList from "@/components/meeting/AttendeesList.vue";

export default {
  name: "AttendanceSection",
  components: {
    AttendeesList,
  },
  props: {
    meetingUsers: {
      type: Array,
      required: true,
    },
    projectTags: {
      type: Array,
      required: true,
    },
    status: {
      type: String,
    },
  },
  data() {
    return {
      searchText: "",
      characterLength: 0,
    };
  },
  methods: {
    handleAttendeeRemove(attendee) {
      this.$parent.handleAttendeeRemove(attendee);
    },
    handleAttendeeAdd(attendee) {
      this.$parent.handleAttendeeAdd(attendee);
      this.searchText = "";
    },
    handleSearchSubmit() {
      if ( this.searchText.trim().length === 0 ) {
        return;
      }
      this.addFirstAttendeeSearchResult();
    },
    addFirstAttendeeSearchResult() {
      let attendee = this.attendeeSearchResults[0];

      this.handleAttendeeAdd(attendee);
    }
  },
  computed: {
    attendeeSearchResults() {
      return this.prospectiveAttendees.filter((attendee) =>
        attendee.name.toLowerCase().includes(this.searchText)
      );
    },
    textSpace() {
      if (this.attendeeSearchResults.length == 0) return false;
      let attendee = this.attendeeSearchResults[0].name;
      let searchRes = attendee
        .toLowerCase()
        .split(this.searchText.toLowerCase());

      return searchRes[1][0] == " " ||
        this.searchText[this.searchText.length - 1] == " "
        ? true
        : false;
    },
    searchResult() {
      if (this.attendeeSearchResults.length == 0) return "";
      let attendee = this.attendeeSearchResults[0].name;
      let searchRes = attendee
        .toLowerCase()
        .split(this.searchText.toLowerCase());

      return searchRes.slice(1);
    },
    attendees() {
      return this.meetingUsers.filter((u) => u.attending === true);
    },
    prospectiveAttendees() {
      return this.meetingUsers.filter((u) => u.attending === false);
    },
    checkStatus() {
      return this.status != "Closed";
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-search {
  &__modal {
    background: white;
    border-radius: 4px;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: all 0.15s ease-in-out;

    &.open {
      top: 42px;
      opacity: 1;
      height: auto;
      z-index: 99;
    }
  }
  &__result {
    position: absolute;
    height: 100%;
    left: 48px;
    top: 0px;
    display: flex;
    align-items: center;
    pointer-events: none;
    font-size: var(--body-p);
    opacity: 0.2;
    &--left-over {
      background: #90a0b7;
    }
  }
}
</style>